export function getColorFromDate(date: Date) {
  if (!date) return 'default';
  const difference = Date.now() - date.valueOf();
  if (difference > 0) return 'errorAction';
  if (difference > -1000 * 3600 * 24 * 7) return 'warningAction';

  return 'default';
}
